import type { IncomeSplitConfigLegacy } from '@fruitful/income-split';

import { requestBuilder } from '../../../http/RequestBuilder';
import type { PaycheckRoutingStatus } from '../../types/PaycheckRouting';

const useUpdateIncomeSplitStatus = requestBuilder.mutation<
    IncomeSplitConfigLegacy,
    { status: PaycheckRoutingStatus },
    { configId: string }
>({
    endpoint: ({ configId }) => `/api/paycheck-routing/${configId}`,
    method: 'PATCH',
});

export default useUpdateIncomeSplitStatus;
